import React from 'react'
import styled from 'styled-components'

import { mobile } from '@/utils/media-query'
import { GradientText } from '@/components/ui/gradient-text'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  font-family: 'PT Mono', monospace;
  font-weight: bold;
  padding: 7px 25px;
  font-size: 16px;

  ${mobile.css`
        font-size: 15px;
    `}
`

type GradientTextButtonProps = {
  text: string
  color?: string
}

export const GradientTextButton: React.FC<GradientTextButtonProps> = ({ text, color }) => (
  <Container>
    {color ? <span style={{ color }}>{text}</span> : <GradientText>{text}</GradientText>}
  </Container>
)
